exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 783px) {\n  body {\n    background: transparent; } }\n", ""]);

// exports
